// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { PropTypes } from 'prop-types';
import { getIconPath } from '@tcp/core/src/utils/utils';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import Image from '@tcp/core/src/components/common/atoms/Image';
import Styles from '../styles/PDPPlccBannerSection.style';
import withStyles from '../../../../../../common/hoc/withStyles';
import { routerPush } from '../../../../../../../utils';

const PDPlccBannerSection = (props) => {
  const {
    className,
    headingLabel,
    subHeadingLabel,
    descriptionLabel,
    isPlcc,
    openModalLearnMore,
    isGuest,
  } = props;

  const learMoreClick = (e) => {
    e.preventDefault();
    requestAnimationFrame(() => {
      const { pathname = 'referrer' } = (window && window.location) || {};
      routerPush(`/home?target=login&successtarget=${pathname}`, '/home/login');
    });
  };

  let icon = 'placebucks_plcc';
  if (isPlcc) {
    icon = 'plcc_cc_icon';
  }
  return (
    <div className={`${className} body`}>
      <div className="promotion-section-pdp-wrapper promo-background-plcc">
        <div className="promotion-section-pdp-icon">
          <Image src={getIconPath(icon)} />
        </div>
        <div className="promotion-plcc-pdp-text">
          {descriptionLabel ? (
            <>
              {headingLabel} {subHeadingLabel} {descriptionLabel}
            </>
          ) : (
            <>
              {headingLabel} {subHeadingLabel}
            </>
          )}
        </div>

        <div className="promotion-section-pdp-left-arrow">
          {!isPlcc && (
            <Anchor
              onClick={isGuest ? learMoreClick : openModalLearnMore}
              noLink
              href="#"
              anchorVariation="primary"
              dataLocator="Learn More"
              target="_self"
              aria-label="Learn more"
            >
              <Image src={getIconPath('right-arrow-plcc')} />
            </Anchor>
          )}
        </div>
      </div>
    </div>
  );
};

PDPlccBannerSection.propTypes = {
  className: PropTypes.string,
  headingLabel: PropTypes.string,
  subHeadingLabel: PropTypes.string,
  descriptionLabel: PropTypes.string,
  isPlcc: PropTypes.bool,
};

PDPlccBannerSection.defaultProps = {
  className: '',
  headingLabel: '',
  subHeadingLabel: '',
  descriptionLabel: '',
  isPlcc: false,
};

export default withStyles(PDPlccBannerSection, Styles);
